// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6ceb1f18","455":"af93eca2","977":"db4dce78"}[chunkId] + ".chunk.js";
};